import { defineMessages } from 'react-intl';

export default defineMessages({
  bannerText: {
    id: 'app.containers.CookieConsentBanner.bannerText',
    defaultMessage:
      'We use analytics tools to understand how you use this app and to fix errors. Your data may be processed by third-party service providers on our behalf. None of this data is ever sold or used for marketing purposes.',
  },
  privacyPolicyLink: {
    id: 'app.containers.CookieConsentBanner.privacyPolicyLink',
    defaultMessage: 'Privacy Policy',
  },
  accept: {
    id: 'app.containers.CookieConsentBanner.accept',
    defaultMessage: 'Accept',
  },
  decline: {
    id: 'app.containers.CookieConsentBanner.decline',
    defaultMessage: 'Decline',
  },
});
